import ContactForm from './ContactForm';

export default function ContactModal({ onClose }) {
  return (
    <div className="bv-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="bv-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="bv-modal-close" onClick={onClose} aria-label="Close">×</button>
        <h2 id="contact-title" className="sr-only">Contact Black Vanilla</h2>
        <ContactForm />
      </div>
    </div>
  );
}
